module.exports = "/_next/static/images/a5b7f19b43ddc36d003a322f449f7c41-complexity@md-2x.jpg";